import type React from 'react';

import { TextOverflow } from '../../../../../../components/TextOverflow';
import type { Company } from '../../../../../../domain/company';
import type { SignalType, TrafficSignal as TrafficSignalType } from '../../../../../../domain/signal';
import { CountryService } from '../../../../../../services/country/country';
import { signalService } from '../../../../../../services/signal/signal';
import { SignalHeader } from '../../SignalHeader';
import {
  StyledSignalItem,
  StyledSignalTagsContainer,
  StyledSignalTitleContainer,
  StyledTooltipContentWrapper,
} from '../../styles';
import { HighlightedText } from '../HighlightedText/HighlightedText';
import { Tag } from '../Tag/Tag';

import { StyledCountryIcon, StyledTooltipContentItem, StyledTooltipContentItemText } from './styles';

type Props = {
  signal: TrafficSignalType;
  company: Company;
};

export const TrafficSignal: React.FC<Props> = ({ signal, company }) => {
  const tags = signalService.getTrafficSignalEventTags(signal);
  const { title, type, countriesText } = signalService.getTrafficSignalEventConfig(signal, company.domain);

  const getTooltipContent = () => {
    return (
      <StyledTooltipContentWrapper>
        {signal.countries.map((countryCode) => (
          <StyledTooltipContentItem key={countryCode}>
            <StyledCountryIcon countryCode={countryCode} size="14px" />
            <StyledTooltipContentItemText>{CountryService.getCountryName(countryCode)}</StyledTooltipContentItemText>
          </StyledTooltipContentItem>
        ))}
      </StyledTooltipContentWrapper>
    );
  };

  return (
    <StyledSignalItem>
      <SignalHeader type={signal.type as SignalType} eventHappenedDaysAgo={signal.eventHappenedDaysAgo} />
      <StyledSignalTitleContainer>
        {type === 'trafficChanges' ? (
          <>
            <StyledCountryIcon countryCode={signal.countries[0]} />
            <TextOverflow text={title} />
          </>
        ) : (
          <>
            {title}
            {''}
            <HighlightedText text={countriesText} tooltipContent={getTooltipContent()} />
          </>
        )}
      </StyledSignalTitleContainer>
      {tags.length ? (
        <StyledSignalTagsContainer>
          {tags.map((tag) => (
            <Tag value={tag} key={tag} />
          ))}
        </StyledSignalTagsContainer>
      ) : null}
    </StyledSignalItem>
  );
};
